import React from 'react';
import SchemaManager from '../../components/SchemaManager';

const AdminPopups = () => {
  return (
    <div className="container-fluid py-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Popups</h2>
        <small className="text-muted">
          Gérer les popups du site
        </small>
      </div>
      
      <SchemaManager
        schemaKey="popups"
        endpoint="/api/popups"
      />
    </div>
  );
};

export default AdminPopups;